module.exports = __webpack_public_path__ + "img/Foto_Press_Release_RemitPro_x_BNC_4.8aba8a05.jpeg";